import { Filters } from '../../../../components/Filters/Filters';

import styles from './LobbyCategoriesBar.module.scss';

export function LobbyCategoriesBar() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Filters
          className={styles.filters}
          leftArrowClassName={styles.leftArrow}
          rightArrowClassName={styles.rightArrow}
        />
      </div>
    </div>
  );
}
